function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 15C18 16.0938 17.125 17 16 17H4C2.90625 17 2 16.0938 2 15V7.125C2 6.65625 2.25 6.1875 2.65625 5.90625L8.4375 1.90625C9.375 1.28125 10.625 1.28125 11.5625 1.90625L17.375 5.90625C17.75 6.1875 18 6.65625 18 7.125V15ZM4 15.5H16C16.2812 15.5 16.5 15.2812 16.5 15V9L11.6562 12.6875C10.6875 13.4375 9.3125 13.4375 8.34375 12.6875L3.5 9V15C3.5 15.2812 3.71875 15.5 4 15.5ZM16.5 7.125L10.7188 3.15625C10.2812 2.84375 9.71875 2.84375 9.28125 3.15625L3.5 7.125L9.25 11.5C9.6875 11.8125 10.3125 11.8125 10.75 11.5L16.5 7.125Z",
  fill: "#636766"
});

function SvgEmailOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOpen);
export default __webpack_public_path__ + "static/media/email-open.fa78d7b8.svg";
export { ForwardRef as ReactComponent };